import $ from 'jquery'
import aa from 'search-insights';

import {
    algoliaAppId,
    algoliaApiKey,
    placeSearchIndex,
    placeSearchSuggestionsIndex,
    locationSearchIndex,
    locationSearchSuggestionsIndex,
} from '../variables'

aa('init', {
    appId: algoliaAppId,
    apiKey: algoliaApiKey,
});

$('.feed-place').on('click', function(e) {
    aa('sendEvents', [
        {
            eventType: 'click',
            eventName: 'Place Clicked',
            index: placeSearchIndex,
            objectIDs: [$(this).data('id').toString()],
        },
    ]);
});

